import { CachedMap } from "@lexriver/cache";
import { RequestMaker } from "./RequestMaker";
import { JsonSettingsItem } from "../json-data-types/JsonSettingsItem";
import { ArrayMethods} from '@lexriver/array-methods'

// url-policy: string
// url-contacts: string
// footer: html

export type AllServerSettingsNames = 
    'url-policy' | 
    'url-contacts' | 
    'footer' |
    'top-logo' |
    'top-second-logo' |
    'top-second-logo-popup' | 
    'top-phone' |
    'main-review' |
    'seo-title' |
    'seo-keywords' |
    'seo-description' |
    'main-phone' |
    'min-wholesale-order' |
    'min-wholesale-order-text' | 
    'min-order-for-free-delivery-text' |
    'basket-text-wholesale' |
    'basket-text-retail' |
    'basket-text-anonymous' |
    'basket-text-sp' |
    'basket-text-administrator'

const filename = 'ServerSettings'
export module ServerSettings{
    
    const cachedAllItems = new CachedMap<string, JsonSettingsItem|undefined>({
        maxAgeInMilliseconds: 15*60*1000,
        useLazyUpdate: true,
        updateFunction: async (key:string) => {
            try {
                const item = await RequestMaker.sendWebsocketJsonRequestAsync<JsonSettingsItem>({
                    query: 'settingsitem',
                    params: {id: key}
                }, filename)
                if(!item){
                    throw new Error('unable to query settingsitem')
                }
                return item
            } catch(x){
                console.warn(x)
                return undefined
                //console.error('##')                
                //throw new Error()
                // well, let's return some default item
                // return {
                //     id: key,
                //     description: 'default description',
                //     type: 'html',
                //     value: 'default value'
                // } as JsonSettingsItem
            }
        }
    })

    export function clearCache(){
        cachedAllItems.clearCache()
    }

    export async function getOnlyValueAsync(id:AllServerSettingsNames){
        const item = await getAsync(id)
        if(item) return item.value
        return ''
    }

    export async function getAsync(id:string){
        try {
            return await cachedAllItems.getAsync(id)
        } catch(x){
            console.warn(x)
            return ''
        }
    }

    export async function adminUpsertAsync(settingsItem:JsonSettingsItem){
        await RequestMaker.sendWebsocketJsonRequestAsync({
            query: 'admin-settingsitem-upsert',
            params: settingsItem
        }, filename)
        //TODO: check result?

        cachedAllItems.clearCacheForKey(settingsItem.id)
    }

    export async function adminGetAllAsync(sort:boolean = true){
        let result = await RequestMaker.sendWebsocketJsonRequestAsync<JsonSettingsItem[]>({
            query: 'admin-settingsitems',
            params:{}
        }, filename)

        if(sort){
            ArrayMethods.sortArrayOfObjectsInPlace(result, {propertyName: 'id', asc: true})
        }

        return result
    }


}